import { render, staticRenderFns } from "./AssignedOrderQueuedDownloads.vue?vue&type=template&id=2435223c&"
import script from "./AssignedOrderQueuedDownloads.vue?vue&type=script&lang=js&"
export * from "./AssignedOrderQueuedDownloads.vue?vue&type=script&lang=js&"
import style0 from "./AssignedOrderQueuedDownloads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports